(function(){
"use strict";
function euro(n){return "\u20ac"+n.toLocaleString("it-IT",{minimumFractionDigits:2,maximumFractionDigits:2})}
var VAR=[];try{VAR=JSON.parse(document.getElementById("demaVariants").textContent)}catch(e){}
function basePrice(){
 var id=(document.getElementById("demaVariantId")||{}).value;
 for(var i=0;i<VAR.length;i++)if(String(VAR[i].id)===String(id))return VAR[i].price/100;
 return VAR.length?VAR[0].price/100:0;
}
function lines(){
 var out=[];
 [].forEach.call(document.querySelectorAll(".dema-form .avp-option input:checked"),function(inp){
  var v=0;
  var d=parseFloat(inp.getAttribute("data-variant-price"));
  if(!isNaN(d)&&d)v=d/100;
  else{
   var lab=inp.closest("label");
   var t=lab?lab.textContent:"";
   var m=t.match(/\+\s*\u20ac\s*([\d.]*\d)(?:,(\d{2}))?/);
   if(m)v=parseFloat(m[1].replace(/\./g,""))+(m[2]?parseInt(m[2],10)/100:0);
  }
  if(v>0)out.push({name:(inp.getAttribute("name")||"")+": "+inp.value,v:v});
 });
 return out;
}
function box(){
 var b=document.getElementById("demaTotal");
 if(b)return b;
 var cta=document.getElementById("demaAdd");
 if(!cta)return null;
 b=document.createElement("div");b.id="demaTotal";
 cta.parentNode.insertBefore(b,cta);
 return b;
}
function rateBox(){
 var b=document.getElementById("demaRate");
 if(b)return b;
 var t=document.getElementById("demaTotal");
 if(!t)return null;
 b=document.createElement("div");b.id="demaRate";
 t.parentNode.insertBefore(b,t.nextSibling);
 return b;
}
function paintRate(tot){
 var b=rateBox(),R=window.DemaRate;
 if(!b||!R)return;
 var html="";
 var k=R.klarna(tot);
 if(k){
  html+='<div class="drt klarna">'+
   '<div class="brand"><span class="wm">Klarna.</span><span class="tagx">3 RATE 0%</span></div>'+
   '<div class="amt">'+R.euro(k.tre)+'<small> al mese</small></div>'+
   '<div class="sub">3 rate senza interessi, oppure 12 rate da '+R.euro(k.dodici)+'</div>'+
   '<div class="fine">3 rate: TAEG 0%. 12 rate: TAEG 17,60%.</div>'+
  '</div>';
 }
 var y=R.younited(tot);
 if(y){
  html+='<div class="drt younited">'+
   '<div class="brand"><span class="flag"><span class="wm">YOUNITED</span></span><span class="tagx">'+y.n+' RATE</span></div>'+
   '<div class="amt">'+R.euro(y.rata)+'<small> al mese</small></div>'+
   '<div class="sub">In '+y.n+' rate. Altre durate disponibili al checkout.</div>'+
   '<div class="fine">TAN fisso 12,28% &middot; TAEG 12,99%. Esempio su '+R.euro(tot)+'.</div>'+
  '</div>';
 }
 b.style.gridTemplateColumns = (k&&y) ? "" : "1fr";
 if(b.innerHTML!==html)b.innerHTML=html;
}
var busy=false,lastKey="";
function sync(){
 if(busy)return;
 busy=true;
 try{
  var base=basePrice();
  var ls=lines();
  var ex=ls.reduce(function(a,b){return a+b.v},0);
  var tot=base+ex;
  var key=tot+"|"+ls.map(function(l){return l.name}).join(",");
  if(key!==lastKey){
   lastKey=key;
   var s=euro(tot);
   var tag=document.getElementById("tag");
   if(tag&&tag.textContent!==s)tag.textContent=s;
   var bar=document.getElementById("demaBarPz");
   if(bar&&bar.textContent!==s)bar.textContent=s;
   var b=box();
   if(b){
    var rows='<div class="dtrow"><span>Telefono</span><b>'+euro(base)+'</b></div>';
    ls.forEach(function(l){rows+='<div class="dtrow"><span>'+l.name+'</span><b>+ '+euro(l.v)+'</b></div>'});
    rows+='<div class="dtrow tot"><span>Totale</span><b>'+s+'</b></div>';
    b.innerHTML=rows;
    b.classList.toggle("solo",ls.length===0);
   }
   paintRate(tot);
   [].forEach.call(document.querySelectorAll(".dbopt,.dup"),function(btn){
    var f=btn.dataset.field,v=btn.dataset.value;
    if(!f)return;
    var inp=document.querySelector('.dema-form .avp-option input[name="'+f.replace(/"/g,'\\"')+'"][value="'+String(v).replace(/"/g,'\\"')+'"]');
    var want=inp&&inp.checked?"true":"false";
    if(btn.getAttribute("aria-pressed")!==want)btn.setAttribute("aria-pressed",want);
   });
  }
 }catch(e){}
 busy=false;
}
function poke(){sync();setTimeout(sync,120);setTimeout(sync,450);setTimeout(sync,1000)}
window.__demaSyncPrice=poke;
["click","touchend","change"].forEach(function(ev){document.addEventListener(ev,function(){poke()},true)});
sync();
[400,900,1600,2600,4000].forEach(function(ms){setTimeout(sync,ms)});
})();
